<template>
  <div class="news-info">
    <div class="container">
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/news/list' }">新闻列表</el-breadcrumb-item>
          <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      
      <div class="content-wrapper">
        <div class="main-content">
          <div class="news-detail" v-loading="loading">
            <div class="news-header">
              <h1 class="news-title">{{ currentNews.subtitle }}</h1>
              <div class="news-meta">
                <span class="category">{{ currentNews.category }}</span>
                <span class="date">{{ formatDate(currentNews.create_time) }}</span>
              </div>
            </div>
            
            <div class="news-content ql-editor" v-html="currentNews.content"></div>
            
            <div class="news-footer">
              <img class="end-img" src="../../assets/newHome1/newsInfoEnd.png" alt="">
              <div class="tags" v-if="currentNews.tags">
                <span class="tag" v-for="(tag, index) in currentNews.tags.split(',')" :key="index">{{ tag }}</span>
              </div>
            </div>
          </div>
        </div>
        
        <div class="sidebar">
          <div class="recomm">
            <div class="recomm-header">
              <h3>热门推荐</h3>
            </div>
            <div class="recomm-list">
              <div class="recomm-item" v-for="(item, index) in recommendNewsList" :key="item.id" @click="viewNewsDetail(item.id)">
                <div class="item-index">{{ index + 1 }}</div>
                <div class="item-content">
                  <div class="item-title">{{ item.title }}</div>
                  <div class="item-info">
                    <span class="item-category">{{ item.category }}</span>
                    <span class="item-date">{{ formatDate(item.create_time) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentNews: {
        id: '',
        title: '',
        subtitle: '',
        category: '',
        content: '',
        create_time: '',
        tags: ''
      },
      recommendNewsList: [],
      loading: false
    }
  },
  watch: {
    // 监听路由变化，当路由参数改变时重新获取新闻详情
    '$route'(to, from) {
      if (to.params.id !== from.params.id) {
        this.getNewsDetail(to.params.id)
        // 同时重新获取推荐列表
        this.getRecommendNewsList()
      }
    }
  },
  methods: {
    // 获取新闻详情
    async getNewsDetail(id) {
      this.loading = true
      try {
        const res = await this.$api.getNewsList({
          id: id
        })
        
        if (res.db && res.db.length > 0) {
          this.currentNews = res.db[0]
        } else {
          this.$message.error('未找到相关新闻')
          this.$router.back()
        }
      } catch (error) {
        this.$message.error('获取新闻详情失败: ' + error.message)
        this.$router.back()
      } finally {
        this.loading = false
      }
    },
    
    // 获取推荐新闻列表
    async getRecommendNewsList() {
      try {
        const res = await this.$api.getNewsList({
          page: 1,
          limit: 10
        })
        this.recommendNewsList = res.db || []
      } catch (error) {
        console.error('获取推荐新闻失败:', error)
      }
    },
    
    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return '--'
      return this.$hnwTools.formatDateTime(timestamp, 'ymd') || '--'
    },
    
    // 查看新闻详情
    viewNewsDetail(id) {
      // 使用 router.replace 配合 scrollTo 实现页面内容更新
      this.$router.push(`/news/info/${id}`)
      window.scrollTo(0, 0)
    }
  },
  created() {
    const newsId = this.$route.params.id
    if (newsId) {
      this.getNewsDetail(newsId)
      this.getRecommendNewsList()
    } else {
      this.$message.error('参数错误')
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.news-info {
  background-color: #f5f5f5;
  min-height: calc(100vh - 80px);
  padding: 20px 0;
  
  .container {
    width: 1200px;
    margin: 0 auto;
    
    .breadcrumb {
      background-color: white;
      padding: 15px 20px;
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      margin-bottom: 20px;
    }
    
    .content-wrapper {
      display: flex;
      gap: 20px;
      
      .main-content {
        flex: 1;
        
        .news-detail {
          background-color: white;
          border-radius: 8px;
          padding: 30px;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          
          .news-header {
            // margin-bottom: 30px;
            padding-bottom: 20px;
            border-bottom: 1px solid #eee;
            
            .news-title {
              font-size: 28px;
              color: #333;
              font-weight: bold;
              line-height: 1.4;
              margin-bottom: 15px;
            }
            
            .news-meta {
              display: flex;
              justify-content: space-between;
              align-items: center;
              
              .category {
                background-color: #063376;
                color: white;
                padding: 5px 12px;
                border-radius: 3px;
                font-size: 14px;
              }
              
              .date {
                color: #999;
                font-size: 14px;
              }
            }
          }
          
          .news-content {
            font-size: 16px;
            line-height: 1.8;
            color: #333;
            
            // 继承Quill编辑器的样式
            @import '~quill/dist/quill.core.css';
            @import '~quill/dist/quill.snow.css';
            
            ::v-deep img {
              max-width: 100%;
              height: auto;
            }
            
            ::v-deep h1, ::v-deep h2, ::v-deep h3, ::v-deep h4, ::v-deep h5, ::v-deep h6 {
              margin: 20px 0 15px 0;
              font-weight: bold;
            }
            
            ::v-deep p {
              margin: 10px 0;
            }
            
            ::v-deep ul, ::v-deep ol {
              padding-left: 30px;
              margin: 15px 0;
            }
            
            ::v-deep li {
              margin: 5px 0;
            }
            
            ::v-deep a {
              color: #063376;
              text-decoration: underline;
            }
          }
          
          .news-footer {
            margin-top: 20px;
            padding-top: 20px;
            border-top: 1px solid #eee;
            .end-img {
              width: 100%;
              height: auto;
            }
            .tags {
              .tag {
                display: inline-block;
                background-color: #f0f0f0;
                color: #666;
                padding: 5px 12px;
                border-radius: 3px;
                font-size: 12px;
                margin-right: 10px;
                margin-bottom: 10px;
                
                &:hover {
                  background-color: #e0e0e0;
                }
              }
            }
          }
        }
      }
      
      .sidebar {
        width: 300px;
        
        .recomm {
          background-color: white;
          border-radius: 8px;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          overflow: hidden;
          
          .recomm-header {
            background-color: #063376;
            color: white;
            padding: 15px 20px;
            
            h3 {
              margin: 0;
              font-size: 18px;
              font-weight: bold;
            }
          }
          
          .recomm-list {
            padding: 10px 0;
            
            .recomm-item {
              display: flex;
              padding: 15px 20px;
              border-bottom: 1px solid #eee;
              cursor: pointer;
              transition: all 0.3s ease;
              
              &:hover {
                background-color: #f9f9f9;
              }
              
              &:last-child {
                border-bottom: none;
              }
              
              .item-index {
                width: 20px;
                height: 20px;
                background-color: #f0f0f0;
                color: #999;
                font-size: 12px;
                text-align: center;
                line-height: 20px;
                border-radius: 50%;
                margin-right: 10px;
                flex-shrink: 0;
              }
              
              .item-content {
                flex: 1;
                
                .item-title {
                  font-size: 14px;
                  color: #333;
                  margin-bottom: 8px;
                  line-height: 1.4;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  overflow: hidden;
                  
                  &:hover {
                    color: #063376;
                  }
                }
                
                .item-info {
                  display: flex;
                  justify-content: space-between;
                  
                  .item-category {
                    background-color: #063376;
                    color: white;
                    padding: 2px 6px;
                    border-radius: 2px;
                    font-size: 12px;
                  }
                  
                  .item-date {
                    color: #999;
                    font-size: 12px;
                    min-width: 62px;
                  }
                }
              }
            }
            
            .recomm-item:nth-child(1) .item-index {
              background-color: #ff4d4d;
              color: white;
            }
            
            .recomm-item:nth-child(2) .item-index {
              background-color: #ff8c00;
              color: white;
            }
            
            .recomm-item:nth-child(3) .item-index {
              background-color: #ffd700;
              color: white;
            }
          }
        }
      }
    }
  }
}
</style>